import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Organization Joint Use Calculation Mode',
    name: 'Organization Joint Use Calculation Mode',
    partialId: PartialId.Standard.create('org_joint_use_calc_mode'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
